import React from 'react';
import { Box } from '@mui/material';

import { getAvailableCandidateVideoUrlAPI } from '@constants';
import { IAvailableCandidate } from '@types';
import { VideoIntroThumb } from 'components/candidate/CandidatesList/components/VideoIntroThumb';
import { ResumeButton } from 'components/candidate/CandidatesList/components/ResumeButton';

interface IAvailableCandidateMaterialsProps {
  candidate: IAvailableCandidate;
  resumeLabel?: string;
  onPlay: () => void;
  onOpenResume: (candidateId: string) => void;
}

export const AvailableCandidateMaterials: React.FC<
  IAvailableCandidateMaterialsProps
> = ({ candidate, resumeLabel, onPlay, onOpenResume }) => (
  <Box display="flex" flexWrap="wrap" alignItems="center" gap={1}>
    {candidate.hasVideo && (
      <VideoIntroThumb
        name={candidate.name}
        videoUrlAPI={getAvailableCandidateVideoUrlAPI(candidate.id)}
        onPlay={onPlay}
      />
    )}
    {candidate.hasResume && (
      <ResumeButton
        label={resumeLabel}
        name={candidate.name}
        onOpen={() => onOpenResume(candidate.id)}
      />
    )}
  </Box>
);
